// Content Security Policy — dedicated Violation Intelligence page.
// See Config.js — this is a thin wrapper that gates the shared
// CspConfig implementation to the "intel" section only.

import React from "react";
import CspConfig from "./Config";

export default function CspIntelligence() {
  return <CspConfig section="intel" />;
}
